import Emitter from "./Emitter";

export default class WonAmountChange extends Emitter {
    constructor(gb) {
        super(gb);
    }

    POKERSTARS_handler(data) {
        if (data.payload && data.payload.winAmount) {
            const dataForXc = {
                "msgId":"rg2xcGameWonUpdated",
                "value": data.payload.winAmount,
            }

            if (this.gb.api && this.gb.api.settings && this.gb.api.settings.pokerstarsOrigin) {
                window.parent.postMessage(JSON.stringify(dataForXc), this.gb.api.settings.pokerstarsOrigin);
            } else {
                window.parent.postMessage(JSON.stringify(dataForXc), "*");
            }
        }
    }


    LNWOGS_handler(data) {
        this.gb.wallet.wonAmountChange(data.payload.winAmount / 100);
    }

    _default(msg) {
        const data = msg ? { wpgaction: "wonAmount", payload: msg.payload } : { wpgaction: "wonAmount" };
        const dataParent = msg ? { wpgaction: "wonAmount.parent", payload: msg.payload } : { wpgaction: "wonAmount.parent" };

        this.emitTop(data);
        this.emitParent(dataParent);
        this.emitiOS(data);
    }
}
